<template>
<div style="margin-top:150px;">
    <section class="banner">
        <div class="col">
            <div class="row">
                <div class="col-md-12" style="padding-top:20px">
                    <div class="col text-center fc">
                        <h1 style="color:#6c63ff;">Virtual Job Fair 2021</h1>
                        <p class="text-center" style="display:none">From 21 JULY 2021 to 31 JULY 2021</p>
                    </div>
                </div>
                <div class="col-md-12 text-center">
                    <a href="https://jobfair.hireclap.com/Candidate_registration.html" class="btn btn-primary mt-2 mb-2 btn-reg">Register</a>
                </div>
            </div>
        </div>
    </section>

    <section class="banner-area">
        <div class="container">
            <div class="row">
                <div class="col-md-6" style="padding:40px">
                    <a href="https://www.techgig.com/codegladiators/signup?sourcetype=MARK_Hireclap"> <img :src="$S3_url+'/Assets/images/Code+Gladiators.png'" style="width: 100%;border-radius: 15px;" alt=""></a>
                </div>
                <div class="col-md-6" style="padding:40px">
                    <a href="https://sites.google.com/hireclap.com/vedantuacademiccounsellor"> <img :src="$S3_url+'/Assets/images/Vedantu+Campus+hiring.jpg'" style="width: 100%;border-radius: 15px;" alt=""></a>
                </div>
            </div>
        </div>
    </section>

    <section class="counter-area">
        <div class="container">
            <div class="row">
            <div class="col-md-4 mb-2">
                 <div class="d-flex">
                     <div class="count-ico text-center">
                         <span class="mdi mdi-account-multiple ico"></span>
                     </div>
                     <div class="text">
                    <strong class="num">65248</strong>
                    <span>PARTICIPANTS</span>
                     </div>
                 </div>
            </div>
            <div class="col-md-4 mb-2">
                <div class="d-flex">
                    <div class="count-ico text-center">
                        <span class="mdi mdi-shopping ico"></span>
                    </div>
                    <div class="text">
                   <strong class="num">60+</strong>
                   <span>COMPANIES</span>
                    </div>
                </div>
             </div>
             <div class="col-md-4 mb-2">
                <div class="d-flex">
                    <div class="count-ico text-center">
                        <span class="mdi mdi-account ico"></span>
                    </div>
                    <div class="text">
                   <strong class="num">183</strong>
                   <span>OPEN POSITIONS</span>
                    </div>
                </div>
             </div>
            </div>
        </div>
    </section>

    <section class="steps">
        <div class="container">
            <div class="card-deck">
                <div class="card" style="background: #f2f2f2;">
                  <img :src="$S3_url+'/Assets/images/register_2.png'" class="card-img-top" alt="..." style="height: 200px;">
                  <div class="card-body">
                    <h5 class="card-title">Step 1</h5>
                    <p class="card-text text-center"><a class="text-secondary" href="https://jobfair.hireclap.com/Candidate_registration.html">Register</a></p>
                  </div>
                </div>
                <div class="card" style="background: #f2f2f2;">
                  <img :src="$S3_url+'/Assets/images/onlinetest_2.png'" class="card-img-top" alt="..." style="height: 200px;">
                  <div class="card-body">
                    <h5 class="card-title">Step 2</h5>
                    <p class="card-text text-center"><a class="text-secondary" href="http://bit.ly/campusvdoassessment">Create video profile</a></p>
                  </div>
                </div>
                <div class="card" style="background: #f2f2f2;">
                  <img :src="$S3_url+'/Assets/images/calendar_2.png'" class="card-img-top" alt="..." style="height: 200px;">
                  <div class="card-body">
                    <h5 class="card-title">Step 3</h5>
                    <p class="card-text text-center text-secondary"><a class="text-secondary" data-toggle="modal" data-target="#exampleModal" href="">Apply for jobs</a></p>
                  </div>
                </div>
              </div>
        </div>
        <div class="container text-center mt-5">
            <h4 class="text-main">Attend the virtual job fair from anywhere & apply for major companies hiring now</h4>
            <h5 style="color: #004085;" class="mt-4 mb-3">No registration fee</h5>
            <h5 style="color: #004085;" class="mb-3">Complete virtual hiring</h5>
            <h5 style="color: #004085;" class="mb-3">Realtime recruitment</h5>
        </div>
    </section>

    <section class="job-list">
        <div class="container">
            <div class="row mb-4">
             <div class="col-md-12 text-center">
                 <h2 class="mb-4">All Jobs</h2>
             </div>
            </div>
            <div class="row row-cols-1 row-cols-md-4">
                <div class="col mb-4">
                  <div class="card">
                    <img src="https://corp.hireclap.com/logo/1a8ba4f793e240a21757d69a76f98a8e.png" class="card-img-top" alt="...">
                    <div class="card-body">
                      <h5 class="card-title">DebugsBunny</h5>
                      <p>Role: Inside Sales Executive</p>
                            <p>Location: Bangalore</p>
                            <p>Salary: 15000 onwards</p>
                            <a href="https://jobfair.hireclap.com/job_details.php?id=719" class="btn btn-primary">View Job</a>
                    </div>
                  </div>
                </div>
  
                <div class="col mb-4">
                    <div class="card">
                        <img src="https://corp.hireclap.com/logo/972ec742aa57469874ff661886ded02a.png" class="card-img-top" alt="...">
                        <div class="card-body">
                          <h5 class="card-title">Avtec</h5>
                          <p>Role: Engineer Trainee-CNC machine operator</p>
                                <p>Location: Hosur</p>
                                <p>Salary: 10K-12K</p>
                                <a href="https://jobfair.hireclap.com/job_details.php?id=725" class="btn btn-primary">View Job</a>
                        </div>
                      </div>
                </div>
                                
                <div class="col mb-4">
                    <div class="card">
                        <img src="https://corp.hireclap.com/logo/fa09b94c683906a70647c5178b6f2e5c.png" class="card-img-top" alt="...">
                        <div class="card-body">
                          <h5 class="card-title">Medicover Hospitals</h5>
                          <p>Role: Nursing Incharge ( Wards / Icu / Wards / Micu / Er )</p>
                                <p>Location: hyderabad</p>
                                <p>Salary: 15000+</p>
                                <a href="https://jobfair.hireclap.com/job_details.php?id=728" class="btn btn-primary">View Job</a>
                        </div>
                      </div>
                </div>
  
                <div class="col mb-4">
                    <div class="card">
                        <img src="https://corp.hireclap.com/logo/f115fb139f9289d40afc7b3dc3db7cfa.png" class="card-img-top" alt="...">
                        <div class="card-body">
                          <h5 class="card-title">Leo Coders, Nagpur</h5>
                          <p>Role:  Django Backend developer</p>
                                <p>Location: Nagpur</p>
                                <p>Salary: As per company norms</p>
                                <a href="https://jobfair.hireclap.com/job_details.php?id=739" class="btn btn-primary">View Job</a>
                        </div>
                      </div>
                </div>
                
  
                
                <div class="col mb-4">
                    <div class="card">
                        <img src="https://corp.hireclap.com/logo/ee1f3a78c728970f6b0759770c55cd5f.jpg" class="card-img-top" alt="...">
                        <div class="card-body">
                          <h5 class="card-title">BYJUs</h5>
                          <p>Role: BUSINESS DEVELOPMENT ASSOCIATE-SALES</p>
                                <p>Location: Pan India</p>
                                <p>Salary: 10 LPA (5PA Fixed + 3 LPA Variable+2LPA allowance )</p>
                                <a href="https://jobfair.hireclap.com/job_details.php?id=743" class="btn btn-primary">View Job</a>
                        </div>
                      </div>
                </div>
  
              <div class="col mb-4">
                  <div class="card">
                      <img src="https://corp.hireclap.com/logo/ae80cebbddafa6ce448703282d671fd8.jpg" class="card-img-top" alt="...">
                      <div class="card-body">
                        <h5 class="card-title">Muthoot Finance ltd</h5>
                        <p>Role: Branch Manager/ Assistant Manager</p>
                              <p>Location: Coimbatore</p>
                              <p>Salary: 18k to 25K</p>
                              <a href="https://jobfair.hireclap.com/job_details.php?id=742" class="btn btn-primary">View Job</a>
                      </div>
                    </div>
              </div>
            <div class="col mb-4">
                    <div class="card">
                        <img src="https://corp.hireclap.com/logo/aa26dafb5c3fc4dc843638eecd41ef4d.jpg" class="card-img-top" alt="...">
                        <div class="card-body">
                          <h5 class="card-title">Rooman Technologies</h5>
                          <p>Role: Technicians</p>
                                <p>Location: Jigani ( Bangalore)</p>
                                <p>Salary: 13705</p>
                                <a href="https://jobfair.hireclap.com/job_details.php?id=751" class="btn btn-primary">View Job</a>
                        </div>
                      </div>
                </div>
  
                <div class="col mb-4">
                    <div class="card">
                        <img src="https://corp.hireclap.com/logo/2e3ad80c3c4cfb48863fb272e23a3d65.jpg" class="card-img-top" alt="...">
                        <div class="card-body">
                          <h5 class="card-title">Digiquint</h5>
                          <p>Role: HR Executive</p>
                                <p>Location: Bangalore</p>
                                <p>Salary: 18000</p>
                                <a href="https://jobfair.hireclap.com/job_details.php?id=750" class="btn btn-primary">View Job</a>
                        </div>
                      </div>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-12 mt-3">
                        <a class="btn btn-primary" href="https://jobfair.hireclap.com/all_jobs.php" style="float: right;">Show all jobs</a>
                    </div>
              </div>
        </div>
    </section>
      
    <section class="logo-slide">
          <div class="container">
            <div class="row mb-3">
                <div class="col-md-12 text-center">
                    <h2 class="mb-4">60+ Participating Companies</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 logo-slide">
                <VueSlickCarousel :infinite="true" :slidesToShow="5" :speed="500" :slidesPerRow="1" :rows="2" :dots="true" :autoplay="true" >
                <div><img :src="$S3_url+'/dev/images/logo100.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo80.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo82.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo90.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo91.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo93.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo94.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo95.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo96.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo80.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo82.jpg'" alt=""></div>
                <div><img :src="$S3_url+'/dev/images/logo90.jpg'" alt=""></div>

                </VueSlickCarousel>
                </div>
            </div>
        </div>
    </section>

    <section class="contact-us">
      <div class="container">
          <div class="row justify-content-center pb-3">
            <div class="col-md-7 text-center">
                <span class="subheading">CONTACT US</span>
                <h2 class="mb-4">Are you an employer ?</h2>
                <a href="https://corp.hireclap.com/register.html" class="btn btn-primary mt-3" data-toggle="tooltip" data-placement="right" title="Register here">Register as Employer</a>
                <p style="display: none">If interested to organise/participate in virtual job fairs, contact us @ <a href="mailto:recruit@hireclap.com">recruit@hireclap.com</a></p>
            </div>
          </div>
      </div>
    </section>

    <section class="participate">
        <div class="container">
            <div class="col text-center">
                <h2>Are you a jobseeker ?</h2>
                <a href="https://jobfair.hireclap.com/Candidate_registration.html" class="btn btn-primary mt-4" data-toggle="tooltip" data-placement="right" title="Register here">Register now</a>
            </div>
        </div>
    </section>

</div>
</template>

<script>
const VueSlickCarousel = () => import(/* webpackPrefetch: true */ "vue-slick-carousel");
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import '../assets/hire.css'
export default {
    name: "Jobfair",
    components: {
    VueSlickCarousel
  }

}
</script>

<style scoped>
.marquee {margin: 0 auto;width: 1200px;height: 30px;white-space: nowrap;overflow: hidden;box-sizing: border-box;position: relative;}.marquee:before, .marquee:after {position: absolute;top: 0;width: 50px;height: 30px;content: "";z-index: 1;}.marquee__content {width: 465%;display: flex;line-height: 30px;animation: marquee 30s linear infinite forwards;}.marquee__content:hover {animation-play-state: paused;}.list-inline {display: flex;justify-content: space-around;width: 33.33%;list-style: none;padding: 0;margin: 0;}@keyframes marquee {0% {transform: translateX(0);}100% {transform: translateX(-66.6%);}}.btn-primary {background-color:#6c63ff !important;border-color: #6c63ff !important;color: #fff !important;}.btn-primary:hover{background-color:#463de0 !important;border-color: #463de0 !important;}.img-fluid {width: 100%;}.fair-date {position: relative;top: 75%;}.discription {background: #dff6fc;padding: 2em 0;}.counter-area {padding: 3em 0;background:#f2f2f2;}.ico {font-size: 40px;color: #fff !important;}.count-ico {height: 60px;width: 60px;background-color: #6c63ff;border-radius: 15px;color: #fff !important;}.counter-area span{color: #1e60a7d9;font-weight: 500;}.num {line-height: 1;font-weight: 700;font-size: 30px;display: block;margin-bottom: 4px;}h1{font-weight: 700;font-size: 3.5rem;}.text{padding-left: 15px;}.subheading {font-size: 13px;font-weight: 700;display: block;margin-bottom: 5px;text-transform: uppercase;color: black;color: #1e60a7d9;letter-spacing: 3px;}.job-list {padding: 5em 0;}.contact-us {padding: 4em 0;}.steps {padding: 4em 0;background: #f2f2f2;}.counter-area{background: #f2f2f2;}.logo-show h2{color: #fff;}.card {box-shadow: 0 0 10px rgba(0, 0, 0, .2);color:#999999 ;}.card h5{color: #000;}.card:hover{box-shadow: 0 0 10px #6c63ffb8;border-color:#6c63ff;}h2{font-weight: 700;}.mobile{display: none;}.list-company {height: 350px;overflow: auto;}.company-list {padding: 2em 0;}.participate {padding: 2em 0;}.ppp{padding-top: 165px;}.fc{margin-left: 35px;}.logo-slide img{width: 150px;}@media only screen and (max-width: 600px){.marquee {margin: 0 auto;width: 420px;height: 30px;white-space: nowrap;overflow: hidden;box-sizing: border-box;position: relative;}.marquee:before, .marquee:after {position: absolute;top: 0;width: 50px;height: 30px;content: "";z-index: 1;}.marquee__content {width: 1270%;display: flex;line-height: 30px;animation: marquee 30s linear infinite forwards;}.marquee__content:hover {animation-play-state: paused;}.logo-slide img{width: 50px;}.list-inline {display: flex;justify-content: space-around;width: 33.33%;list-style: none;padding: 0;margin: 0;}@keyframes marquee {0% {transform: translateX(0);}100% {transform: translateX(-66.6%);}}}
</style>  